export const defaultTypes = {
  code: '',
  country: '',
  eu: false,
  vatName: '',
  phoneCode: '',
  vatPercent: 0,
};
